import { colors } from '@insurancemenu/imenu-components-lib';
import { createUseStyles } from 'react-jss';

const styles = {
  tableRow: {
    borderBottom: `1px solid ${colors.neutral[300]}`,
    '&:last-of-type': {
      borderBottom: 'none',
    },
  },
  tableCell: {
    font: { size: '1.6rem', lineHeight: '2.4rem' },
    color: colors.neutral[900],
    letterSpacing: '0.02rem',
    padding: '1.6rem 1rem',
    '&:first-child': {
      paddingLeft: '3.3rem',
    },
    '&:last-child': {
      paddingRight: '2.4rem',
    },
  },
  tag: {
    font: {
      size: '1.2rem',
      lineHeight: '1.8rem',
      weight: 400,
    },
    textAlign: 'center',
    color: colors.neutral[900],
    width: '8.8rem',
    verticalAlign: 'middle',
    padding: '0.4rem 0rem',
    borderRadius: '14px',
  },
  tagType_GROUP: { backgroundColor: colors.green[300] },
  tagType_CUSTOM: { backgroundColor: colors.purple[300] },
};

const createStyles = createUseStyles(styles);

export { createStyles };
